import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, NIRLABA_LEMBAGA } from "../../utils/index";

const { SearchBar } = Search;

const LembagaNirlabaList = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const [modalDelete, setModalDelete] = useState(false);

  const load = () => {
    axios
      .get(NIRLABA_LEMBAGA, { timeout: API_TIMEOUT })
      .then((res) => {
        const data = res.data?.data || [];
        setRows(data.map((item, i) => ({ ...item, nomor: i + 1 })));
      })
      .catch((err) => alert(err));
  };

  useEffect(() => {
    load();
  }, []);

  const hapus = () => {
    axios
      .delete(NIRLABA_LEMBAGA + "/" + idHapus, { timeout: API_TIMEOUT })
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Lembaga dihapus", "success");
          setModalDelete(false);
          load();
        }
      })
      .catch((err) => alert(err));
  };

  const columns = [
    { dataField: "nomor", text: "No.", sort: true },
    { dataField: "nama_lembaga", text: "Nama lembaga", sort: true },
    { dataField: "jenis_lembaga", text: "Jenis", sort: true },
    { dataField: "kontak", text: "Kontak" },
    {
      dataField: "aktif",
      text: "Aktif",
      formatter: (cell) => (Number(cell) === 1 ? "Ya" : "Tidak"),
    },
    {
      dataField: "id",
      text: "Aksi",
      formatter: (cell) => (
        <div>
          <Button
            color="success"
            size="xs"
            className="mr-2"
            onClick={() => dispatch(push(`/admin/nirlaba/lembaga/${cell}/edit`))}
          >
            Edit
          </Button>
          <Button
            color="danger"
            size="xs"
            onClick={() => {
              setIdHapus(cell);
              setModalDelete(true);
            }}
          >
            Hapus
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">
          Lembaga <span className="fw-semi-bold">NGO / Swasta</span>
        </h2>
      </div>
      <Widget>
        <ToolkitProvider keyField="id" data={rows} columns={columns} search>
          {(props) => (
            <div>
              <div className="d-flex justify-content-between mb-3">
                <SearchBar {...props.searchProps} />
                <Button
                  color="primary"
                  onClick={() => dispatch(push("/admin/nirlaba/lembaga/new"))}
                >
                  Tambah lembaga
                </Button>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
                bootstrap4
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(false)}>
        <ModalHeader>Hapus lembaga</ModalHeader>
        <ModalBody>Yakin menghapus lembaga ini?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDelete(false)}>
            Batal
          </Button>
          <Button color="danger" onClick={hapus}>
            Hapus
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default LembagaNirlabaList;
